import { ITimezone } from '@newroom-connect/library/interfaces';

export class DateHelper {
  private static readonly TIMEZONES: ITimezone[] = [
    {
      'value': 'Europe/Berlin',
      'label': 'Berlin, Germany',
      'offset': 1
    }
  ];

  /**
   * Get the current timestamp as UNIX timestamp in milliseconds.
   *
   * @returns Current timestamp as UNIX timestamp in milliseconds.
   */
  public static getCurrentTimestamp(): number {
    return new Date().getTime();
  }

  /**
   *
   * @returns
   */
  public static getTimezones(): ITimezone[] {
    return DateHelper.TIMEZONES;
  }

  /**
   *
   * @param value
   * @param minDate
   * @param maxDate
   *
   * @returns
   */
  public static isDateInRange(value: Date | string | null, minDate: Date | string | null, maxDate: Date | string | null): boolean {
    if (!value) {
      return false;
    }

    const date = new Date(value);
    const isMinDateValid = !minDate || (!!minDate && (date >= new Date(minDate)));
    const isMaxDateValid = !maxDate || (!!maxDate && (date <= new Date(maxDate)));

    // If both min and max limits are set both ends should be true for the date in range to be true
    return isMinDateValid && isMaxDateValid;
  }
}
